module.exports = __webpack_public_path__ + "img/coupon-ticket.e068b454.png";